import tmsApi from './../api/tmsApi';

export default {
  namespaced: true,
  state: {
    files: [],
    count_files: 0,
    onProcess: [],
    query: {
      page: {
        number: 1,
        count: 20,
      },
    },
    errors: {
      actions: [],
    },
  },
  mutations: {
    ADD_DATA(state, data) {
      state.files = data;
    },
    CLEAR_DATA(state) {
      state.files.splice(0);
    },
    REMOVE_FILE(state, fileName) {
      const index = state.files.findIndex(f => f.file_name === fileName);
      state.files.splice(index, 1);
    },
    CLEAR_ON_PROCESS_DATA(state) {
      state.onProcess.splice(0);
    },
    REMOVE_ON_PROCESS_DATA(state, jobId) {
      const index = state.onProcess
        .findIndex(f => f.job_id === jobId);
      state.onProcess.splice(index, 1);
    },
    ADD_ON_PROCESS_DATA(state, data) {
      const eData = state.onProcess
        .find(p => p.job_id === data.job_id);

      if (!eData) {
        state.onProcess.push(data);
        return;
      }

      if (eData.state !== data.state) {
        const eIndex = state.onProcess
          .findIndex(p => p.job_id === data.job_id);
        state.onProcess.splice(eIndex, 1, data);
      }
    },
    SET_INFO_DATA(state, count) {
      state.count_files = count;
    },
    SET_QUERY_PAGE(state, number) {
      state.query.page.number = number;
    },
    ADD_ERROR(state, error) {
      state.errors.actions.push(error);
    },
    REMOVE_ERROR(state, error) {
      const index = state.errors.actions.findIndex(err => err === error);
      state.errors.actions.splice(index, 1);
    },
  },
  getters: {
    files(state) {
      return state.files;
    },
    files_info(state) {
      return state.count_files;
    },
    page_count(state) {
      return state.query.page.count;
    },
    page_number(state) {
      return state.query.page.number;
    },
    onProcess(state) {
      return state.onProcess;
    },
  },
  actions: {
    LOAD_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const { number, count } = state.query.page;
      const offset = (number - 1) * count;
      const limit = count;
      const query = `
      {
        files: exported_reports(
          offset: ${offset},
          limit: ${limit}
        ) {
          job_id
          file_url
          file_name
          file_size
          options
          view
          format
          report {
            name
            title
            iconClass
          }
          created_at
        }
      }`;
      commit('CLEAR_DATA');
      return api(query, 'files').then(({ data }) => {
        const { files } = data;
        commit('ADD_DATA', files);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_DATA');
      });
    },
    LOAD_INFO_DATA({ commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const query = `
      {
        files: exported_reports {
          job_id
          file_url
          file_name
          file_size
          options
          view
          format
          report {
            name
            title
            iconClass
          }
          created_at
        }
      }`;
      return api(query, 'files').then(({ data }) => {
        const { files } = data;
        commit('SET_INFO_DATA', files.length);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_INFO_DATA');
      });
    },
    LOAD_ON_PROCESS_REPORT({ commit, rootState }, onProcessOnly = false) {
      const api = tmsApi.buildRetry(rootState.token);
      const query = `
      {
        files: get_on_process_reports(on_process_only: ${onProcessOnly.toString()}) {
          job_id
          file_url
          file_name
          file_size
          options
          view
          format
          report {
            name
            title
            iconClass
          }
          state
          created_at
        }
      }`;
      return api(query, 'get_on_process_reports').then(({ data }) => {
        const { files } = data;
        files.forEach((file) => {
          commit('ADD_ON_PROCESS_DATA', file);
        });
        return files.length;
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_ON_PROCESS_REPORT');
      });
    },
    DELETE_FILE({ commit, rootState }, fileName) {
      const api = tmsApi.build(rootState.token);
      const mutation = `
      mutation {
        delete: delete_exported_report(file_name: "${fileName}")
      }`;
      return api(mutation, 'delete_exported_report').then(() => {
        commit('REMOVE_FILE', fileName);
      }).catch(() => {
        commit('ADD_ERROR', 'DELETE_FILE');
      });
    },
    DELETE_ON_PROCESS_REPORT({ commit, rootState }, jobId) {
      const api = tmsApi.build(rootState.token);
      const mutation = `
      mutation {
        remove_on_process_report(job_id: "${jobId}")
      }`;
      return api(mutation, 'delete_exported_report').then(() => {
        commit('REMOVE_ON_PROCESS_DATA', jobId);
      }).catch(() => {
        commit('ADD_ERROR', 'DELETE_ON_PROCESS_REPORT');
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/report_files.js